import { isAxiosError } from "axios";

const STATUS_MESSAGES: Record<number, string> = {
  401: "Oturumunuzun süresi doldu, lütfen tekrar giriş yapın.",
  403: "Bu işlem için yetkiniz yok.",
  404: "Kayıt bulunamadı.",
  409: "Bu kayıt başka bir kayıtla çakışıyor.",
  413: "Dosya çok büyük.",
  429: "Çok fazla istek, lütfen biraz bekleyin.",
};

const SERVER_ERROR = "Sunucu hatası oluştu, lütfen tekrar deneyin.";
const NETWORK_ERROR = "Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edin.";

function serverMessage(data: unknown): string | null {
  if (!data || typeof data !== "object" || !("message" in data)) return null;
  const message: unknown = (data as { message: unknown }).message;
  if (typeof message === "string" && message.trim()) return message;
  if (Array.isArray(message)) {
    const parts = message.filter((m): m is string => typeof m === "string" && m.trim() !== "");
    if (parts.length > 0) return parts.join(", ");
  }
  return null;
}

/**
 * Hata nesnesinden kullanıcıya gösterilecek Türkçe mesajı üretir.
 * Öncelik: API'nin `message` alanı → HTTP durum koduna göre mesaj →
 * ağ hatası → `fallback`.
 */
export function errorMessage(e: unknown, fallback: string): string {
  if (!isAxiosError(e)) return fallback;

  const response = e.response;
  if (response) {
    const fromServer = serverMessage(response.data);
    if (fromServer) return fromServer;
    const byStatus = STATUS_MESSAGES[response.status];
    if (byStatus) return byStatus;
    if (response.status >= 500) return SERVER_ERROR;
    return fallback;
  }

  if (e.code === "ERR_NETWORK" || e.request) return NETWORK_ERROR;
  return fallback;
}
